import MUITr from '@mui/material/TableRow';
import React from 'react';

import { tableMapper } from '~/common/components/PropertyMappers/tableMapper';

type TrProps = React.ComponentProps<typeof MUITr>;

const Tr = React.forwardRef<any, TrProps>(({ children, ...props }, ref) => {
  const tableProps = tableMapper(props);

  return (
    <MUITr ref={ref} {...tableProps}>
      {children}
    </MUITr>
  );
});

Tr.displayName = 'Tr';

export default Tr;
